import React, { useState, useEffect } from "react";
import { BodyText, Heading } from "../../elements";
import AccountOverviewForm from "../../sections/account-overview-form";
import "./style.scss";
import useQuery from "../../utils/useQuery";
import api from "../../utils/api";
import { getOrderDetail, getOrderDetailByNo } from "../../services/orderService";
import getSiteInfo from "../../utils/getSiteInfo";
import { format } from "../../utils";
import { isEmptyObject } from "../../utils/siteUtils";
import moment from "moment";
const CarBookingConfirmation = ({ fields }) => {
  const { headingType, heading, locationHeadingType, locationHeading, terms, footerHeadingType, footerHeading, footerBody, customerNumberLabel, orderNumberLabel, orderDateLabel, deliveryMethodLabel, dateLabel, timeLabel } = fields;
  const { scheduleid, orderNo, booking } = useQuery();
  const [bookDate, bookStartTime, bookEndTime] = booking ? decodeURIComponent(window.atob(booking)).split(" ") : [];
  const [location, setLocation] = useState(null);
  const [formSections, setFormSections] = useState([]);
  const loadLocation = async () => {
    const { data } = await api.booking.caseDetail.get({
      scheduleid
    });
    if (!isEmptyObject(data)) {
      const { DeliveryAddressStreet1, DeliveryAddressPostalCode, DeliveryAddressCity } = data;
      setLocation(`<p>${DeliveryAddressStreet1} <br/>${DeliveryAddressPostalCode} ${DeliveryAddressCity}</p>`);
    }
  };
  const loadOrder = async () => {
    const siteInfo = await getSiteInfo();
    const order = await getOrderDetailByNo(orderNo);
    const { orderExtraData } = order || {};
    const { carStartDeliveryDate, carEndDeliveryDate } = orderExtraData || {};
    const date = carStartDeliveryDate ? moment(carStartDeliveryDate).format("YYYY-MM-DD") : bookDate;
    const start = carStartDeliveryDate ? moment(carStartDeliveryDate).format("HH:mm") : bookStartTime;
    const end = carStartDeliveryDate ? moment(carEndDeliveryDate).format("HH:mm") : bookEndTime;
    const _formSections = [
      {
        items: [
          {
            label: customerNumberLabel.value,
            value: order?.customerNumber
          },
          {
            label: orderNumberLabel.value,
            value: orderNo
          },
          {
            label: orderDateLabel.value,
            value: order?.orderDate && format(order?.orderDate, siteInfo.dateFormat)
          },
          {
            label: deliveryMethodLabel.value,
            value: order?.orderExtraData?.carDeliveryMethod
          },
          {
            label: dateLabel.value,
            value: format(date, siteInfo.dateFormat)
          },
          {
            label: timeLabel.value,
            value: `${start} - ${end}`
          }
        ]
      }
    ];
    setFormSections(_formSections);
  };
  useEffect(() => {
    loadLocation();
    loadOrder();
  }, []);
  return (
    <section className="car-booking-confirmation grid">
      <Heading type={headingType} html={heading} typographyClass="type-h3" className="title" />
      <AccountOverviewForm formSections={formSections} />
      <div className="confirmation-footer">
        <Heading type={footerHeadingType} html={footerHeading} className="confirmation-footer-title" />
        <BodyText html={footerBody} className="confirmation-footer-body" />
      </div>
      <div className="info-container">
        {location && (
          <>
            <Heading type={locationHeadingType} html={locationHeading} className="location-heading" />
            <BodyText html={location} className="shop-address" />
          </>
        )}
        <BodyText html={terms} className="link-to-terms" />
      </div>
    </section>
  );
};
export default CarBookingConfirmation;
